import React from 'react';

export function ReIndex(props) {
  return (
    <>
      <h1>Search Indexing</h1>

      <a style={{ marginRight: '0.8rem' }} className="btn btn-outline-primary" href="/api/dev/ReIndex" target="_blank">Re-index</a> (add/update but not delete the old records)
      <div style={{ marginTop: '2rem' }}>
        <a className="btn btn-outline-info" href="/api/dev/RemoveIndex" target="_blank">Remove index</a> (after this, please run 'Re-index')
      </div>
    </>
  );
}
